import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'JM',
    name: 'Julián M.',
    location: 'Buenos Aires',
    product: 'Megapack Biohacking del Sueño',
    quote: 'Dormí 8 horas seguidas por primera vez en dos años. El Tomo 3 del entorno cambió todo — nunca hubiera pensado que la temperatura del cuarto era el problema.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Rosario',
    product: 'Megapack + Sistema Avanzado',
    quote: 'Siempre pensé que era ansiosa. En realidad tenía el cuarto mal configurado y cenaba a las 22:00. Con el Tracker identifiqué el patrón en 7 días. Resuelto.'
  }, {
    initials: 'MA',
    name: 'Marcos A.',
    location: 'Córdoba',
    product: 'Megapack Biohacking del Sueño',
    quote: 'Me despertaba a las 3 AM todas las noches. El Bono 6 me dio el protocolo exacto. Ya no pasa. Ni una sola vez en las últimas 3 semanas.'
  }, {
    initials: 'SF',
    name: 'Sofía F.',
    location: 'Mendoza',
    product: 'Megapack + Sistema Avanzado',
    quote: 'El directorio de suplementos me ahorró semanas de búsqueda y mucha plata. Ahora sé exactamente qué comprar y dónde.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    product: 'Megapack Biohacking del Sueño',
    quote: 'El ritual de 10 minutos del Bono 4 es lo que más me cambió. Pensé que no iba a poder sostenerlo. Llevo 5 semanas sin fallar una noche.'
  }];
  return <section className="py-24 relative" data-id="element-271">
      <div className="container mx-auto px-4" data-id="element-272">
        <div className="text-center mb-16" data-id="element-273">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" data-id="element-274">
            <span aria-hidden="true" className="text-red-500" data-id="element-275">
              ❤️
            </span>{' '}
            MÁS PERSONAS QUE YA DUERMEN DIFERENTE
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-276">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`p-8 rounded-2xl bg-slate-800/30 border border-white/5 flex flex-col ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-277">
              <div className="flex items-center gap-4 mb-6" data-id="element-278">
                <div className="w-12 h-12 rounded-full bg-slate-700 text-white flex items-center justify-center font-bold text-lg border border-white/10" data-id="element-279">
                  {t.initials}
                </div>
                <div data-id="element-280">
                  <div className="flex text-amber-400 mb-1" data-id="element-281">
                    {[...Array(5)].map((_, idx) => <Star key={idx} size={14} fill="currentColor" data-id="element-282" />)}
                  </div>
                  <div className="text-sm font-bold text-white" data-id="element-283">
                    {t.name}{' '}
                    <span className="text-slate-500 font-normal ml-1" data-id="element-284">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-xs text-amber-500/80 mt-0.5" data-id="element-285">
                    {t.product}
                  </div>
                </div>
              </div>
              <p className="text-slate-300 leading-relaxed text-sm italic flex-grow" data-id="element-286">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}